import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { LookupService } from "../../../services/lookup.service";
import { forkJoin } from "rxjs";
import { KeyValueObject } from "../../../models/core/KeyValueObject";
import { GridComponent } from "@progress/kendo-angular-grid";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { NewRequestDevice } from "../../../models/request/new-request/new-request-device";
import { DeviceModelsService } from "../../../services/device-models.service";
import { DeviceModelDto } from "../../../models/device/device-model-dto";
import { RequestsService } from "../../../services/requests.service";
import { RequestDevicesService } from "../../../services/request-devices.service";
import { WarehouseStockService } from "../../../services/warehouse-stock.service";
import { Activity } from "../../../models/activity/activity";
import { DialogService } from "@progress/kendo-angular-dialog";
import { DevicesHierarchicalSelectorComponent } from "../../devices-hierarchical-selector/devices-hierarchical-selector.component";
import { ReserveResult } from "../../../enums/reserve-result.enum";
import { RequestTypeService } from "../../../services/request-type.service";
import { NotificationService } from "../../../../core/services/notification.service";
import { Router } from "@angular/router";

@Component({
	selector: 'setup-device-serial-personal-warehouse',
	templateUrl: './setup-device-serial-personal-warehouse.html',
	styleUrls: ['./setup-device-serial-personal-warehouse.scss',
		'../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
		'../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
	]
})
export class SetupDeviceSerialPersonalWarehouse implements OnInit {

    @ViewChild("requestDevicesGrid") requestDevicesGrid: GridComponent;

    @Input() requestId: number;
    @Input() activity: Activity;
    @Input() requestTypeId: number;
    
    @Output() onContinueEvent: EventEmitter<any> = new EventEmitter();
    @Output() onCancelEvent: EventEmitter<any> = new EventEmitter();

    dataSaving: boolean = false;
    loading: boolean = false;
	dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };

    deviceTypes: KeyValueObject[] = [];
    deviceModels: DeviceModelDto[] = [];
    dropDownDeviceModels: DeviceModelDto[] = [];
    deviceSuppliers: DeviceModelDto[] = [];
    dropDownDeviceSuppliers: DeviceModelDto[] = [];
    warrantyRequestTypes: number[] = [];
    senderWarehouses: KeyValueObject[] = [];
    recipientUserName: string;
    senderWarehouseId: number;

    requestDevices: NewRequestDevice[] = [];
    serialsFrom1C: string[] = [];
    additionalRequestId: number;

    checkboxDisabled: boolean = false;

    constructor(
        public requestsService: RequestsService,
        public deviceModelsService: DeviceModelsService,
        public lookupService: LookupService,
        public requestDevicesService: RequestDevicesService,
        public warehouseStockService: WarehouseStockService,
        public dialogService: DialogService,
        public requestTypesService: RequestTypeService,
        private notificationService: NotificationService,
        private router: Router,
    ) { }

    ngOnInit(): void {
        let deviceTypes$ = this.lookupService.getData('device-types', null);
		let deviceModels$ = this.deviceModelsService.getAll();
        let warrantyRequestTypes$ = this.requestTypesService.getWarrantyRequestTypes();
        this.initRequestDevices();

        forkJoin(deviceTypes$,  deviceModels$, warrantyRequestTypes$)
            .subscribe(([deviceTypes, deviceModels, warrantyRequestTypes]) => {
                this.deviceTypes = deviceTypes;
                this.deviceModels = deviceModels;
                this.dropDownDeviceModels = [];
                this.deviceSuppliers = this.deviceModels.filter(x => x.parentId == null);
                this.dropDownDeviceSuppliers = [];
                this.warrantyRequestTypes = warrantyRequestTypes;
            });
    }

    initRequestDevices() {
        this.loading = true;
        this.warehouseStockService.getWarehouseSenderRecipientData(this.requestId, this.activity.performerUserId).subscribe(warResp => {
            let senderWarehouse = warResp.senderWarehouses[0];
            this.senderWarehouses = warResp.senderWarehouses;
            this.senderWarehouseId = senderWarehouse.id;
            this.recipientUserName = warResp.recipientUserName;
            this.loadRequestDevices();
        });
    }

    loadRequestDevices() {
        this.loading = true;
        this.warehouseStockService.getRefilItemsForStorekeeperPersonalWarehouse(this.requestId, this.activity.performerUserId, this.senderWarehouseId).subscribe(resp => {
            this.additionalRequestId = resp.additionalRequestId;
            this.requestDevices = resp.requestDevicesActions;
            this.requestDevices.forEach(f => {
                f.checkboxDisabled = !!f.sn1C || !f.isAvailableIn1C;
                f.toDelivery = f.quantityIssued > f.quantityReal;
            });
            this.serialsFrom1C = resp.serialsFrom1C;
            this.loading = false;
        })
    }

    saveChanges() {
        if (this.additionalRequestId !== 0) {
            this.notificationService.confirmation({
                title: 'Предупреждение',
                enableHtml: true,
                message: `Для данного сотрудника имеются еще заявки, по которым необходимо выдать товар. Продолжить выдачу?`,
                type: 'question',
                confirmButtonText: 'Продолжить',
                cancelButtonText: 'Завершить выдачу',
                showCloseButton: false
            },
            () => {
                this.issueItems();
                window.open(`/requests/${this.additionalRequestId}/#activities`, '_blank');
            },
            () => {
                this.issueItems()
            });
        } else {
            this.issueItems()
        }
    }

    issueItems() {
        this.dataSaving = true;
        this.warehouseStockService.issueItemsPersonalWarehouse(this.requestId, this.requestDevices, this.senderWarehouseId).subscribe(res => {
            if (res.isSuccessful) {
                this.onContinueEvent.emit();
            }
            this.dataSaving = false;
        })

        // this.requestsService.saveSerialRequestDevices(this.requestDevices).subscribe(() => {
        //     this.onContinueEvent.emit();
        //     this.dataSaving = false;
        // });
    }

    cancel() {
        this.onCancelEvent.emit();
    }

    getNameById(items: KeyValueObject[] = [], id: number): string {
        return items.some(x => x.id == id)
            ? items.find(x => x.id == id).name
            : '';
    }

    createNewRequestDevice(): NewRequestDevice {
        let device = new NewRequestDevice();
        device.manuallyAdded = true;
        device.requestId = this.requestId;
        device.activityId = this.activity.activityId;
        return device;
    }

    addNewRequestDevice() {
        const dialogRef = this.dialogService.open({ 
            content: DevicesHierarchicalSelectorComponent, 
            title: 'Добавление оборудования',
            width: '80%',
            height: '870px',
            minWidth: '800px'
        });
        const devicesSelector = <DevicesHierarchicalSelectorComponent>dialogRef.content.instance;

        devicesSelector.height = 500;
        devicesSelector.disableFreeItems = !this.isWarrantyRequest;
        devicesSelector.requestId = this.requestId;
        devicesSelector.onCancel.subscribe(() => {
            dialogRef.close();
        });
        devicesSelector.onContinue.subscribe((requestDevices: NewRequestDevice[]) => {
            dialogRef.close();

            requestDevices.forEach(requestDevice => {
                requestDevice.requestId = this.requestId;
                requestDevice.quantityIssued = requestDevice.quantity;
                requestDevice.quantity = 0;
                requestDevice.quantityReal = 0;
                requestDevice.toDelivery = true;
            });

            this.requestDevices.unshift(...requestDevices);
        });
        // this.requestDevicesGrid.addRow(this.createNewRequestDevice())
    }

    public deviceTypeChange(deviceTypeId: number, requestDevice: NewRequestDevice = null) {
        if (requestDevice) {
            requestDevice.deviceModelId = null;
            requestDevice.deviceSupplierId = null;
        }
    }

    public deviceSupplierChange(supplierId: number, requestDevice: NewRequestDevice = null) {
        if (requestDevice) {
            requestDevice.deviceModelId = null;
        }
    }

    public handleDeviceModelsDropdownOpen(deviceSupplierId: number) {
		this.dropDownDeviceModels = this.deviceModels != null && deviceSupplierId
            ? this.deviceModels.filter(x => x.parentId === deviceSupplierId)
            : [];
	}

    public handleDeviceSuppliersDropdownOpen(deviceTypeId: number) {
        this.dropDownDeviceSuppliers = this.deviceModels != null && deviceTypeId
            ? this.deviceSuppliers.filter(x => x.typeId == deviceTypeId)
            : [];
    }

    public editRequestDeviceHandler({ sender, rowIndex, dataItem }) {
        this.handleDeviceSuppliersDropdownOpen(dataItem.deviceTypeId);
        this.handleDeviceModelsDropdownOpen(dataItem.deviceSupplierId);

		sender.editRow(rowIndex);
	}

    public rowClass(args) {
		return {
			'cursor-pointer': true,
            'cell-pink': args.dataItem.isAvailableIn1C === false
		};
	}

    snChanged(item: NewRequestDevice, sn: string) {
        item.checkboxDisabled = (!!item.sn1C
            && !this.serialsFrom1C.includes(sn))
            || !item.isAvailableIn1C;
    }

    checkboxModelChanged(id: number) {
        const device = this.requestDevices.find(x => x.requestDeviceWarehouseRefillId === id);
        const quantityDiff = device.quantity - device.quantityReal;
        const quantityIssuedDiff = device.quantityIssued - device.quantityReal;
        device.quantityIssued = device.toDelivery
            ? quantityDiff > quantityIssuedDiff ? +device.quantityIssued + quantityDiff : device.quantityIssued
            : device.quantityReal;
    }

    quantityIssuedChanged(issued: number, id: number) {
        const device = this.requestDevices.find(x => x.requestDeviceWarehouseRefillId === id);
        device.toDelivery = issued > device.quantityReal;
    }

    isIssuedLessThanReal(item: NewRequestDevice): boolean {
        return +item.quantityIssued < item.quantityReal;
    }

    manuallyAdded(requestDevice: NewRequestDevice): boolean {
        return requestDevice.quantity === 0
    }

    get isWarrantyRequest(): boolean {
        return this.warrantyRequestTypes.some(x => x == this.requestTypeId);
    }

    get isSaveDisabled(): boolean {
        return this.requestDevices.some(s => this.isIssuedLessThanReal(s));
    }

    get gridHeight(): number {
        return 400;
    }

    saveRequestDevice({ dataItem }: any) {
    }

    removeRequestDevice({ dataItem }: any) {
    }
}
